import axios from "axios";

const api = axios.create({
  baseURL: "https://app.turnora.es/api", // Esto es en producción
  // baseURL: "http://127.0.0.1:8000/api",
  // Change to function on local
});

// Interceptor de petición: añade token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta: detecta token inválido o expirado
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token inválido o expirado
      localStorage.removeItem("token"); // limpiar token
      window.location.href = "/"; // redirigir a login (opcional)
      // Podrías mostrar un toast o mensaje aquí
    }
    return Promise.reject(error);
  }
);

export default api;